import { isEmpty } from './strings';

export function isSorabanAdmin(email?: string | null, is_advisor?: boolean) {
  if (isEmpty(email) || !is_advisor) return false;

  const isSorabanAdmin = Boolean(
    email &&
      is_advisor &&
      email.startsWith('hello+') &&
      email.endsWith('@soraban.com'),
  );

  return isSorabanAdmin;
}

export function isSorabanEmail(email?: string | null, is_advisor?: boolean) {
  if (isEmpty(email) || !is_advisor) return false;

  const isSorabanEmail = Boolean(
    email && is_advisor && email.endsWith('@soraban.com'),
  );

  return isSorabanEmail;
}

export function getAdminQuestionnaireViewLink(
  questionnaireId: number,
  companyId: number,
  isFullPath: boolean = false,
) {
  const relativePath: string = `/preview/${companyId}/questionnaire/${questionnaireId}`;
  const fullPath: string = `${window.location.origin}${relativePath}`;

  return isFullPath ? fullPath : relativePath;
}

export function getAdminDocumentDropOffPreviewLink(
  questionnaireId?: number,
  companyId?: number,
  token?: string,
) {
  if (token) {
    const previewLinkWithToken = `/document-drop-off?token=${token}&preview=true`;
    return `${window.location.origin}${previewLinkWithToken}`;
  } else if (!questionnaireId || !companyId) {
    return undefined;
  }

  const relativePath = `/preview/document-drop-off?questionnaireId=${questionnaireId}&companyId=${companyId}`;
  return `${window.location.origin}${relativePath}`;
}
